import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var DataRouting = require("lib/routing/DataRouting");

var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");

var QuizDisplay = require("components/writing/quizzes/QuizDisplay");
var PaginationControls = require("components/utility/PaginationControls");
var Spinner = require("components/utility/Spinner");
var NoActivityBlock = require("components/data/subjects/shared/NoActivityBlock");
var TruncatedDataNote = require("components/data/TruncatedDataNote");
var EmptyState = require("components/data/EmptyState");

require("data/data_quizzes");

function propsToConditions(props) {
	var conditions = _.pick(props, 
		"startDate", "endDate", "textVariety", "textID", "userIDs", "order"
	);

	conditions.perPage = props.perPage || DataRouting.PER_PAGE;
	conditions.withTotal = true;

	return conditions;
}

function sortItems(quizzes) {
	return _.sortBy(quizzes, (x) => (new Date(x.completed_at)).valueOf()).reverse();
}
// large requests will store all quizzes in props and paginate on FE
// small requests will use BE pagination
function pickQuizSelector(state, props) {
	if ($wr.isLargeRequest(props.userIDs)) {
		return sortItems(WritingSelectors.quizzes({ state, conditions: propsToConditions(props) }))
	} else {
		return sortItems(WritingSelectors.quizzesPaginated({ state, page: (props.page || 1), conditions: propsToConditions(props) }))
	}
}
// large requests count all quizzes held in props
// small requests get total from BE
function totalCount(state, props) {
	if (props.userIDs && $wr.isLargeRequest(props.userIDs)) {
		return $wr.frontEndPaginationTotal(state.quizzes);
	} else {
		return WritingSelectors.quizTotal({state, conditions: propsToConditions(props)})
	}
}

@connect(
	(state, props) => ({
		loading: WritingSelectors.isLoadingQuizzes({ state, key: 'index', userIDs: props.userIDs }),
		quizzes: pickQuizSelector(state, props),
		totalCount: totalCount(state,props)
	}),
	(dispatch, props) => ({
		populateData: () => {
			// TODO: standardize FE requests
			if ($wr.isLargeRequest(props.userIDs)) {
				var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "order")
				var actionFunction = WritingActions.fetchQuizzes
				var options = {
					embeds: ["quiz.answers", "quiz.evaluation", "answer.question", "answer.meta_data",
						"answer.evaluation", "question.answer_options", "question.answer_options",
						"question.answer_options", "evaluation.autograder_data", "evaluation.score_details"], cache: true
				}
				return new Promise(function (resolve, reject) {
					resolve($wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null));
				}).catch(() => console.log("Quizzes failed to load"))
			} else {
				return dispatch(WritingActions.fetchQuizzes({
					conditions: propsToConditions(props),
					embeds: [
						"quiz.answers", "quiz.evaluation",
						"answer.question", "answer.meta_data", "answer.evaluation",
						"question.answer_options",
						"question.answer_options",
						"question.answer_options",
						"evaluation.autograder_data", "evaluation.score_details"
					],
					page: props.page || 1,
					cache: true
				}));
			}
		}
	})
)
@providePopulateData()
class DataQuizzes extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { currentQuizPage: 1 }

	}
	// FE pagination controlls for large requests
	onFrontendPaginationChange(page) {
		this.setState({ currentQuizPage: page });
	}
	render() {
		if (this.props.loading) {
			var loadingDisplay = <Spinner />
		} else {
			if (this.props.showFullData) {
				var quizzes = this.props.quizzes;
			} else {
				var quizzes = _.first(this.props.quizzes, 1);
			}

			if (this.props.fakePerPage) {
				quizzes = _.first(quizzes, this.props.fakePerPage)
			}

			if (quizzes && quizzes.length > 0) {
				var quizDisplays = _.map(quizzes, (quiz) => {
					if (quiz) {
						var enabled = { ...this.props.enabled };
						return (
							<div key={ quiz.id }>
								<QuizDisplay quizID={ quiz.id } view="quizzes" enabled={ enabled } />
							</div>
						);	
					}
				})
				if (!this.props.showFullData) {
					var truncatedRow = <TruncatedDataNote total={ this.props.quizzes.length } type={ QUIZZES } />
				}
			} else {
				if (this.props.sketchEmptyState) {
					var noQuizzes = <NoActivityBlock userIDs={ this.props.userIDs } contentType="Quizzes" />
				} else {
					var emptyState = <EmptyState type={ QUIZZES } />
				}
			}

			if (this.props.onPageChange && this.props.totalCount) {
				if (this.props.showFullData & !this.props.fakePerPage) {
					if ($wr.isLargeRequest(this.props.userIDs)) {
						// chunck all quizzes for pagination
						quizDisplays = _.chunk(quizDisplays, DataRouting.PER_PAGE)[this.state.currentQuizPage - 1]
						//	pagination control
						var pagination = (
							<PaginationControls page={this.state.currentQuizPage}
								perPage={DataRouting.PER_PAGE}
								totalCount={this.props.totalCount}
								onPageChange={this.onFrontendPaginationChange} />
						);
					} else {
						var pagination = (
							<PaginationControls page={this.props.page || 1}
								perPage={this.props.perPage || DataRouting.PER_PAGE}
								perPageOptions={PaginationControls.DEFAULT_PAGE_OPTIONS}
								totalCount={this.props.totalCount}
								onPageChange={this.props.onPageChange} />
						);
					}
				}	
			}
		}

		return (
			<div className="dataQuizzes">
				{ loadingDisplay }
				{ pagination }
				{ emptyState }
				{ noQuizzes }
				{ quizDisplays }
				{ truncatedRow }
				{ pagination }
			</div>
		)
	}
}

var QUIZZES = "quizzes";

DataQuizzes.defaultProps = {
	enabled: {}
}

DataQuizzes.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from above
	userIDs: PropTypes.array,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	page: PropTypes.number,
	perPage: PropTypes.number,
	fakePerPage: PropTypes.number,
	order: PropTypes.string,
	startDate: PropTypes.string, 
	endDate: PropTypes.string, 
	textVariety: PropTypes.string,
	textID: PropTypes.string,
	showFullData: PropTypes.bool,
	onPageChange: PropTypes.func,
	sketchEmptyState: PropTypes.bool,
	studentList: PropTypes.string,

	// Reference QuizDisplay 'enabled'
	enabled: PropTypes.object,

	// Data from @connect
	loading: PropTypes.bool,
	quizzes: PropTypes.array,
	totalCount: PropTypes.number,

	// Handlers from @connect
	populateData: PropTypes.func,
})

module.exports = DataQuizzes;


// WEBPACK FOOTER //
// ./modules/components/data/subjects/DataQuizzes.js